import React, { FC } from "react";
import { ReactComponent as EmptyImg } from "../../assets/illustrations/empty-96x96.svg";
import { NewWalletAction } from "../../components/actions";
import { Button, Icon } from "../common";

export const NoWallets: FC = () => {
  return (
    <div className="bg-slate-100 rounded-2xl p-6 md:px-12 md:py-16 flex flex-col items-center justify-center">
      <div className="max-w-[400px] text-center flex flex-col items-start md:items-center">
        <EmptyImg />

        <div className="text-base text-gray-500 mb-4 mt-6 md:mt-9">
          No wallets yet
        </div>

        <div className="text-base text-gray-300 mb-8 md:mb-4 text-left md:text-center">
          You can add your first wallet here or when working on your first
          invoice
        </div>

        <NewWalletAction>
          {(action) => (
            <Button variant={Button.variant.SECONDARY} onClick={action}>
              <span className="flex flex-row gap-x-2">
                <Icon
                  icon="Add"
                  size={24}
                  className="text-gray-500"
                  disableFill
                />
                Add wallet
              </span>
            </Button>
          )}
        </NewWalletAction>
      </div>
    </div>
  );
};
